import { eclipseServerData } from '../utils/eclipseServerData';
/**
 * Reseller co-branding from the server. Branding is present for any reseller
 * site (name/banner show for all resellers); the co-branded logo is gated
 * behind the resellerBranding FT via `showResellerLogo`.
 */
export const useResellerBranding = () => {
  var _resellerBrandingInfo;
  const {
    resellerBrandingInfo
  } = eclipseServerData.get();
  return {
    isResellerOffering: Boolean(resellerBrandingInfo),
    showResellerLogo: Boolean((resellerBrandingInfo == null || (_resellerBrandingInfo = resellerBrandingInfo.config) == null ? void 0 : _resellerBrandingInfo.showResellerLogo) && (resellerBrandingInfo == null ? void 0 : resellerBrandingInfo.logo)),
    resellerBrandingInfo
  };
};
//# sourceMappingURL=useResellerBranding.js.map